module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.valueType == 'TagSerializer') ? _c('span', {
    staticClass: "label label-info"
  }, [_vm._v("\n  " + _vm._s(_vm.value.name) + "\n")]) : _c('span', [_vm._v(_vm._s(_vm.value))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a7476c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/TableCellInner.vue
// module id = 661
// module chunks = 0